import React from 'react';

import { useTranslation } from 'react-i18next';

import { IconCheckCircle } from '@pkg/components/actions/CopyTextAction/assets';

import { AcceptAction, IconWrapper, Item, Label, RejectAction, StyledActions } from './Actions.style';

export interface ActionsProps {
    status?: 'accepted' | 'rejected' | 'pending';
    onAccept?: () => void;
    onReject?: () => void;
}

export function Actions({ status = 'pending', onAccept, onReject }: ActionsProps) {
    const [translate] = useTranslation('marketplace');

    const accepted = status === 'accepted';
    const rejected = status === 'rejected';
    const pending = status === 'pending';

    const checkMarkup = accepted ? (
        <IconWrapper>
            <IconCheckCircle />
        </IconWrapper>
    ) : null;

    return (
        <StyledActions>
            <Item>
                <RejectAction
                    ariaLabel={pending ? translate('asset-reject-offer-cta-a11y') : undefined}
                    pressed={rejected || undefined}
                    disabled={accepted || !onReject}
                    onAction={onReject}
                >
                    <Label>{translate(rejected ? 'asset-rejected-badge' : 'asset-reject-offer-cta')}</Label>
                </RejectAction>
            </Item>

            <Item>
                <AcceptAction
                    ariaLabel={pending ? translate('asset-accept-offer-cta-a11y') : undefined}
                    pressed={accepted || undefined}
                    disabled={rejected || !onAccept}
                    onAction={onAccept}
                >
                    <Label>{translate(accepted ? 'asset-accepted-badge' : 'asset-accept-offer-cta')}</Label>

                    {checkMarkup}
                </AcceptAction>
            </Item>
        </StyledActions>
    );
}
